import * as React from 'react';
const StudentsIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={25} fill="none" {...props}>
    <g clipPath="url(#a)">
      <path
        fill={props.color}
        d="M22.005 4.603a1.988 1.988 0 0 0-1.34-1.898L14.2.425A6.5 6.5 0 0 0 9.897.417l-6.543 2.29a1.985 1.985 0 0 0-1.346 1.896c0 .867.529 1.611 1.347 1.896L6 7.423v1.682c0 3.31 2.69 6 6 6 3.309 0 6-2.69 6-6V7.423l2-.698v4.38a1 1 0 0 0 2 0V4.626c0-.009.004-.015.004-.024ZM16 9.105c0 2.206-1.794 4-4 4s-4-1.794-4-4v-.984l1.86.65a6.508 6.508 0 0 0 4.276 0L16 8.12v.984Zm-2.522-2.223a4.501 4.501 0 0 1-2.957 0L4.015 4.595l6.544-2.29a4.492 4.492 0 0 1 2.976.004L20 4.607l-6.521 2.275Zm6.478 15.926a1 1 0 0 1-1.91.593c-.787-2.53-3.272-4.297-6.045-4.297s-5.258 1.767-6.045 4.297a1 1 0 0 1-1.91-.594c1.044-3.358 4.315-5.703 7.955-5.703 3.64 0 6.91 2.346 7.955 5.704Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill={props.color} d="M0 .105h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default StudentsIcon;
